import React from 'react';
import styled, { css } from 'styled-components';
import { SmallBodyBold, ApproveIcon as BaseApproveAllIcon } from '@ubeya/shared-web/components';

const ApproveAllIcon = styled(BaseApproveAllIcon)`
  min-width: 26px;

  ${({ $isActive }) =>
    !$isActive &&
    css`
      > g > path {
        stroke: ${({ theme }) => theme.colors.grey3}!important;
      }

      &:hover {
        > g > path {
          stroke: ${({ theme }) => theme.colors.greenPositive}!important;
        }
      }
    `}
`;

const ApproveAggregateRenderer = ({ rowData: { summarized, subRows } }) => {
  if (summarized) {
    return <></>;
  }

  const totalApproves =
    subRows &&
    subRows.filter(({ approved, clientApproved, isExternal }) => {
      if (isExternal && clientApproved) {
        return true;
      }

      return approved;
    }).length;

  if (totalApproves === subRows.length) {
    return <ApproveAllIcon $isActive />;
  }

  return (
    <SmallBodyBold>
      {totalApproves}/{subRows.length}
    </SmallBodyBold>
  );
};

export default ApproveAggregateRenderer;
